import { NgModule } from '@angular/core';

import { DecimalPipe } from '@angular/common';

import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';

import { routing, appRoutingProviders } from './app.routing';
import { AuthzoneComponent } from './authzone/authzone.component';
import { authInterceptorProviders } from './services/auth-user-service/auth.interceptor';
import { VehiclesModule } from './vehicles/veh.module';
import { AccidentsModule } from './accidents/accidents.module';
import { LicensesModule } from './licenses/licenses.module';
import { InsurancesModule } from './insurances/insurances.module';
import { InspectionsModule } from './inspection/insp.module';
import { OwnersModule } from './owners/owners.module';
import { BusStopsModule } from './busstops/busstops.module';
import { DashboardModule } from './dashboard/dashboard.module';
import { AuthzoneModule } from './authzone/authzone.module';
import { LoginModule } from './login/login.module';
import { DialogAssignComponent } from './dialog/assign/dialog.component.assign';
import { DialogVehicles } from './dialog/vehicles/dialog.component.veh';
import { DialogAccidents } from './dialog/accidents/dialog.component.acc';
import { DialogInspection } from './dialog/inspeccions/dialog.component.insp';
import { DialogOwner } from './dialog/owners/dialog.component.own';
import { DialogBusStop } from './dialog/busstops/dialog.component.busstops';
import { DialogInsurances } from './dialog/insurances/dialog.component.ins';
import { DialogLicenses } from './dialog/licenses/dialog.component.lic';

import { ManageUsersModule } from './manage-users/manage-users.module';
import { AuthUserService } from './services/auth-user-service/auth-user.service';
import { TwoDigitDecimaNumberDirective } from './pipes/digit-decim-number.directive';

import { AngularMaterialModule } from './angular-material.module';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

export function tokenGetterFactory(){
  return localStorage.getItem('access_token');
}

@NgModule({
  declarations: [
    AppComponent,
    DialogAssignComponent,
    DialogVehicles,
    DialogAccidents,
    DialogInspection,
    DialogLicenses,
    DialogInsurances,
    DialogOwner,
    DialogBusStop,
    TwoDigitDecimaNumberDirective
  ],
  imports: [
    BrowserModule,
    RouterModule,
    BrowserAnimationsModule,
    HttpClientModule,
    LoginModule,
    AuthzoneModule,
    AngularMaterialModule,
    VehiclesModule,
    AccidentsModule,
    BusStopsModule,
    LicensesModule,
    InsurancesModule,
    InspectionsModule,
    OwnersModule,
    DashboardModule,
    FormsModule,
    ManageUsersModule,
    routing,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  providers: [
    authInterceptorProviders,
    AuthUserService,
    DecimalPipe,
    appRoutingProviders,
    {useClass: HashLocationStrategy, provide: LocationStrategy}
  ],
  exports: [ TranslateModule ],
  bootstrap: [ AppComponent ],
  entryComponents: [ ]
})
export class GrenadaGestioModule { }

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "../../assets/i18n/", ".json");
}